export default __webpack_public_path__ + "static/media/logo_600.9b445791.png";